// Biblioteca de trechos prontos do assistente (Campanhas2).
// Regras: nome ({{contact.name}}) liberado; dados de exame/consulta entram
// como espaços [[CAMPO]] para o usuário preencher clicando na variável.
// Cada categoria tem 4 opções: inserir uma avulsa ou as 4 como conjunto Spintax.
export const SNIPPET_CATEGORIES = [
  {
    key: 'saudacao',
    options: [
      'Olá, {{contact.name}}!',
      'Oi, {{contact.name}}!',
      'Olá {{contact.name}}, tudo bem?',
      'Prezado(a) {{contact.name}},',
    ],
  },
  {
    key: 'apresentacao',
    options: [
      'Passando para informar que',
      'Vim informar que',
      'Entramos em contato para informar sobre',
      'Viemos avisar que',
    ],
  },
  {
    key: 'consulta',
    options: [
      'Sua consulta com o [[MEDICO]] está agendada para o dia *[[DATA]]*, às *[[HORA]]*.',
      'Informamos que sua consulta com o [[MEDICO]] será no dia *[[DATA]]*, às *[[HORA]]*.',
      'Viemos avisar que sua consulta com o [[MEDICO]] está marcada para o dia *[[DATA]]*, às *[[HORA]]*.',
      'Confirmando sua consulta com o [[MEDICO]]: dia *[[DATA]]* às *[[HORA]]*.',
    ],
  },
  {
    key: 'retirada',
    options: [
      'Seu agendamento está disponível para retirada no Setor de Call Center.',
      'O seu agendamento já está disponível para retirada no Setor de Call Center.',
      'Você já pode retirar seu agendamento no Setor de Call Center.',
      'O agendamento encontra-se disponível para retirada no Setor de Call Center.',
    ],
  },
  {
    key: 'confirmacao',
    options: [
      'Por favor, confirme o recebimento desta mensagem.',
      'Por gentileza, confirme o recebimento desta mensagem.',
      'Aguardamos a sua confirmação de recebimento desta mensagem.',
      'Por favor, responda esta mensagem informando se poderá comparecer.',
    ],
  },
  {
    key: 'encerramento',
    options: [
      'Agradecemos!',
      'Agradecemos a atenção!',
      'Obrigada! Fico à disposição.',
      'Agradecemos a atenção e ficamos à disposição.',
    ],
  },
  {
    key: 'lembrete',
    options: [
      'Lembrando que você ainda não retirou seu agendamento.',
      'Este é um lembrete: seu agendamento segue aguardando retirada.',
      'Passando para lembrar que seu agendamento ainda não foi retirado.',
      'Não se esqueça: seu agendamento está aguardando retirada.',
    ],
  },
  {
    key: 'cancelamento',
    options: [
      'Devido a um imprevisto, este atendimento foi cancelado.',
      'Por um imprevisto na agenda, este atendimento foi cancelado.',
      'Devido a uma mudança na agenda, este atendimento foi cancelado.',
      'Infelizmente este atendimento precisou ser cancelado.',
    ],
  },
  {
    key: 'remanejamento',
    options: [
      'Sua consulta foi remanejada. Confira abaixo a nova data e horário.',
      'Houve remanejamento na agenda. Veja a nova data e horário abaixo.',
      'Sua consulta mudou de data. Confira a nova data e horário.',
      'Remarcamos sua consulta. Confira abaixo a nova data e horário.',
    ],
  },
  {
    key: 'guia_retorno',
    options: [
      'A guia de retorno já está disponível para retirada.',
      'Sua guia de retorno encontra-se disponível para retirada.',
      'Você já pode retirar sua guia de retorno.',
      'Informamos que sua guia de retorno está liberada para retirada.',
    ],
  },
];
